import React , { useState, useEffect }from 'react';
import PropTypes from 'prop-types';
import { vectors } from '../../data/vectors';
import styled from 'styled-components';

const Holder = styled.div`
  .shadow { mix-blend-mode: multiply; }
`;

function HairFront({currentAvatar, features, images, path}) {

    const [style, setStyle] = useState(null);

    useEffect(() => {
      if ( currentAvatar !== 'f' ) {
        setStyle( features.hairstyle )
      } else {
        setStyle( `${features.hairstyle}_${features.hairlength}` )
      }
    }, [currentAvatar, features.hairstyle, features.hairlength]);

    if( !style ) { return null; }

    return (
      <Holder className={features.haircolour}>
        <img className="shadow" src={images( `${path}_hairstyle_${style}_front_shadow.png` )} alt="hairstyle shadow"/>
        <img src={images( `${path}_hairstyle_${style}_front.png` )} alt="hairstyle"/>
        { vectors[`${currentAvatar}_hairstyle_${style}_front_vector`] }
      </Holder>
    )
}

HairFront.propTypes = {
  features: PropTypes.object,
  images: PropTypes.func,
  path: PropTypes.string,
  currentAvatar: PropTypes.string.isRequired,
};

export default HairFront;
